// extracted by mini-css-extract-plugin
export default {"loadingState":"Loader_loadingState__d+ZgM","loading":"Loader_loading__uoAuL"};